import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import { clinicInteriorImage, clinicPhone, clinicEmail } from '../mock';

const content = {
  terms: {
    eyebrow: 'Website Terms',
    title: 'Terms and',
    italic: 'conditions.',
    breadcrumb: 'Terms & Conditions',
    intro:
      'This website provides general information about Uptown Physiotherapy Clinic and its services. It is not a substitute for assessment, diagnosis, or treatment from a regulated health professional.',
    sections: [
      {
        title: 'Use of website information',
        text:
          'Content on this website is provided for general educational and clinic information purposes. Individual care decisions should be made with a registered health professional after an appropriate assessment.',
      },
      {
        title: 'Appointments and availability',
        text:
          'Phone call booking is preferred. Appointment requests submitted through the website are not confirmed until the clinic contacts you or confirms by phone.',
      },
      {
        title: 'Coverage and billing',
        text:
          'Insurance, WSIB, motor-vehicle-accident claims, direct billing, and reimbursement depend on each plan, claim, and insurer. Patients are encouraged to confirm coverage requirements with their insurer.',
      },
    ],
  },
  privacy: {
    eyebrow: 'Privacy Policy',
    title: 'Privacy',
    italic: 'policy.',
    breadcrumb: 'Privacy Policy',
    intro:
      'Uptown Physiotherapy Clinic treats patient information as confidential health information and aims to collect only the information needed to respond to inquiries and provide care.',
    sections: [
      {
        title: 'Personal health information',
        text:
          'Information submitted through the website should be limited to what is needed for the clinic to contact you. Please call the clinic for urgent questions or sensitive health details.',
      },
      {
        title: 'Consent and confidentiality',
        text:
          'Patients have the right to understand recommended care, ask questions, give or refuse consent, and expect respectful handling of personal health information.',
      },
      {
        title: 'Ontario care standards',
        text:
          'Physiotherapy care in Ontario is regulated by the College of Physiotherapists of Ontario. Patients may confirm a physiotherapist registration through the College public register.',
      },
    ],
  },
  notice: {
    eyebrow: 'Legal Notice',
    title: 'Legal',
    italic: 'notice.',
    breadcrumb: 'Legal Notice',
    intro:
      'The information on this website is intended to support informed conversations with the clinic and does not create a practitioner-patient relationship by itself.',
    sections: [
      {
        title: 'No emergency service',
        text:
          'This website and its forms are not monitored as an emergency service. For urgent medical concerns, call emergency services or seek immediate medical care.',
      },
      {
        title: 'Professional judgement',
        text:
          'Treatment recommendations depend on assessment findings, patient consent, clinical judgement, and each patient’s goals and health history.',
      },
      {
        title: 'External coverage rules',
        text:
          'Referral, reimbursement, and claim rules may vary by insurer, employer benefit plan, WSIB claim, or automobile insurer.',
      },
    ],
  },
};

const LegalPage = ({ type }) => {
  const page = content[type] || content.terms;

  return (
    <div className="App bg-white">
      <Header />
      <PageHero
        eyebrow={page.eyebrow}
        title={page.title}
        italic={page.italic}
        description={page.intro}
        image={clinicInteriorImage}
        breadcrumbs={[{ label: 'Home', to: '/' }, { label: page.breadcrumb }]}
      />

      <section className="py-16 lg:py-24">
        <div className="max-w-[900px] mx-auto px-6 space-y-10">
          {page.sections.map((section) => (
            <div key={section.title}>
              <h2 className="text-[24px] font-bold tracking-tight text-neutral-900">{section.title}</h2>
              <p className="mt-4 text-[15px] leading-relaxed text-neutral-700">{section.text}</p>
            </div>
          ))}

          <div className="rounded-2xl border border-neutral-200 bg-neutral-50 p-6">
            <h2 className="text-[20px] font-bold tracking-tight text-neutral-900">Contact</h2>
            <p className="mt-3 text-[15px] leading-relaxed text-neutral-700">
              Call <a href="tel:+15192522752" className="font-medium text-[#CA0028]">{clinicPhone}</a> or email{' '}
              <a href={`mailto:${clinicEmail}`} className="font-medium text-[#CA0028]">{clinicEmail}</a>.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LegalPage;
